import { createSelector } from 'reselect';

import RessourceReducerFactory from 'helpers/RessourceReducerFactoryHelpers';
import RessourceSelectorsFactory from 'helpers/RessourceSelectorsFactoryHelpers';

import {
    default as createActionCreator,
    HTTP_METHODS,
} from 'helpers/RessourceActionCreatorsFactoryHelpers';

/*
 * Configuration
 */

export const ressourceName = 'ME';

/*
 * Actions
 */

export const REQUEST_GET_ME = `REQUEST_GET_${ressourceName}`;
export const REQUEST_GET_ME_SUCCESS = `REQUEST_GET_${ressourceName}_SUCCESS`;
export const REQUEST_GET_ME_ERROR = `REQUEST_GET_${ressourceName}_ERROR`;

/*
 * Reducer
 */

export const APIMeReducer = RessourceReducerFactory({
    ressourceName,
});

/*
 * Action Creators
 */

export const getMe = createActionCreator({
    type: REQUEST_GET_ME,
    method: HTTP_METHODS.GET,
    url: '/me',
    withPagination: false,
});

/*
 * Selectors
 */
export const {
    getItemSelector,
    isLoadingSelector,
    getCountSelector,
    getCurrentItemsSelector,
} = RessourceSelectorsFactory({
    reducerName: 'APIMe',
});

export const isCurrentUserSuperAdminSelector = createSelector(
    [getItemSelector],
    (currentUser) => {
        if (!currentUser) return false;
        return !!currentUser.is_super_admin;
    },
);
